export const DEPARTMENTS = [
  'IT', 'HR', 'Finance', 'Marketing', 'Sales', 'Operations', 'Engineering'
];

export const POSITIONS = [
  'Software Engineer', 'HR Manager', 'Financial Analyst', 'Marketing Specialist',
  'Sales Representative', 'DevOps Engineer', 'QA Engineer', 'Product Manager',
  'Data Analyst', 'System Administrator'
];